import "prismjs/themes/prism-tomorrow.css";
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import Prism from 'prismjs';
import "prismjs/components/prism-json";
import {
	Box,
	HStack,
	Text,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../../components/form'
import { fetchWrapper } from '../../../../helpers';
import { LuArrowLeftCircle, LuTrash2 } from "react-icons/lu";

function Create({ getPage, channel_id }) {

	const [customerList, setCustomerList] = useState([])
	const [payload, setPayload] = useState('');
	const [header, setHeader] = useState('');
	const [voiceType, setVoiceType] = useState('text'); // 'text' | 'recorded'

	const [initialValues, setInitialValues] = useState(null);

	const [formData, setFormData] = useState({
		account_name: '',
		customer_id: '',
		method: '',
		url: '',
		headers: [{ key: '', value: '' }],
		payloads: [{ key: '', value: '' }],
		status_id: '',
		voice_type: 'text',
	});

	const FormSchema = Yup.object().shape({
		account_name: Yup.string().required('Required'),
		customer_id: Yup.string().required('Required'),
		url: Yup.string().required('Required'),
		method: Yup.string().required('Required'),
	});

	useEffect(() => {
		loadCustomerList()
	}, [])

	useEffect(() => {
		if (!initialValues || formData.headers.length > 0) {
			setInitialValues({ ...formData });
		}
		Prism.highlightAll();
	}, []);

	useEffect(() => {
		Prism.highlightAll();
	}, [payload]);

	const loadCustomerList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer/list`;
		const response = await fetchWrapper.get(url)
		const customerList = response.data;

		const allCustomersEntry = { id: 0, name: "All Customers" };
		const updatedData = [allCustomersEntry, ...customerList];
		let data = updatedData?.map(item => ({ id: item.id, name: item.business_name || item.name }))
		const db = { data: data };
		setCustomerList(db);
	}

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		const api_config = {
			header: header,
			payload: payload,
			url: values.url,
			method: values.method,
			voice_type: voiceType,
		}

		const postData = {
			customer_id: values.customer_id,
			status_id: values.status_id,
			channel_id: channel_id,
			api_config: api_config,
			account_name: values.account_name,
			
		}

		const url = `${process.env.REACT_APP_API_URL}/channel_api_config/create`;
		await fetchWrapper.post(url, postData)
		getPage('list', channel_id)
	}

	const methodList = {
		data: [
			{ id: 'Post', name: 'Post' },
			{ id: 'Get', name: 'Get' }
		]
	};

	const statusList = {
		data: [
			{ id: '1', name: 'Active' },
			{ id: '0', name: 'InActive' }
		]
	};

	const addHeader = () => {
		const updatedFormData = {
			...formData,
			headers: [...formData.headers, { key: '', value: '' }]
		};
		setFormData(updatedFormData);
	};

	const addPayload = () => {
		const updatedFormData = {
			...formData,
			payloads: [...formData.payloads, { key: '', value: '' }]
		};
		setFormData(updatedFormData);
	};

	const removeHeader = (index) => {
		const updatedHeadersData = [...formData.headers];
		updatedHeadersData.splice(index, 1);
		setFormData({ ...formData, headers: updatedHeadersData });
	};

	const removePayload = (index) => {
		const messageObject = {};
		const updatedPayloadData = [...formData.payloads];
		updatedPayloadData.splice(index, 1);

		updatedPayloadData.forEach(p => {
			messageObject[p.key] = p.value;
		});
		setPayload(messageObject);
		setFormData({ ...formData, payloads: updatedPayloadData });
	};

	const handleHeaderChange = (index, field, value) => {
		const messageObject = {};
		const updatedHeaders = formData.headers.map((h, i) =>
			i === index ? { ...h, [field]: value } : h
		);

		updatedHeaders.forEach(h => {
			messageObject[h.key] = h.value;
		});

		setHeader(messageObject);
		setFormData(prev => ({ ...prev, headers: updatedHeaders }));
	};

	const handlePayloadChange = (index, field, value) => {
		const messageObject = {};
		const updatedPayloadData = formData.payloads.map((p, i) =>
			i === index ? { ...p, [field]: value } : p
		);

		updatedPayloadData.forEach(p => {
			messageObject[p.key] = p.value;
		});

		Prism.highlightAll();
		setPayload(messageObject);
		setFormData(prev => ({ ...prev, payloads: updatedPayloadData }));
	};

	return (
		<>
			<div className="setting_detail_section">
				<HStack>
					<Box>
						<LuArrowLeftCircle
							style={{ fontSize: '24px', cursor: 'pointer' }}
							onClick={() => getPage('list', channel_id)}
						/>
					</Box>
					<Box>
						<h2 className="main_heading">SMS API Account</h2>
					</Box>
				</HStack>

				<Form
					enableReinitialize
					validationSchema={FormSchema}
					initialValues={initialValues}
					onSubmit={onSubmit}
				>
					<InputText
						name="account_name"
						title="Account Name"
						inputProps={{ isRequired: true }}
						placeholder="Please Enter Account Name"
					/>

					<SelectField name="customer_id" title="Customers" list={customerList} isRequired />

					{/* Voice Type Toggle */}
					<Box mb="15px">
						<Text fontSize="14px" mb="8px">Voice Type</Text>
						<HStack spacing={0} border="1px solid #CCCCCC" borderRadius="6px" overflow="hidden" w="fit-content">
							<Box
								px="20px"
								py="8px"
								fontSize="13px"
								fontWeight="500"
								cursor="pointer"
								bg={voiceType === 'text' ? '#2563eb' : '#FFFFFF'}
								color={voiceType === 'text' ? '#FFFFFF' : '#000000'}
								onClick={() => {
									setVoiceType('text');
									setFormData(prev => ({ ...prev, voice_type: 'text' }));
								}}
								transition="all 0.2s"
							>
								Text
							</Box>
							<Box
								px="20px"
								py="8px"
								fontSize="13px"
								fontWeight="500"
								cursor="pointer"
								bg={voiceType === 'recorded' ? '#2563eb' : '#FFFFFF'}
								color={voiceType === 'recorded' ? '#FFFFFF' : '#000000'}
								borderLeft="1px solid #CCCCCC"
								onClick={() => {
									setVoiceType('recorded');
									setFormData(prev => ({ ...prev, voice_type: 'recorded' }));
								}}
								transition="all 0.2s"
							>
								Recorded
							</Box>
						</HStack>
					</Box>



					{/* API Endpoint */}
					<HStack alignItems="end" w="100%">
						<Box w="15%">
							<SelectField name="method" title="API Endpoint" list={methodList} isRequired />
						</Box>
						<Box w="85%">
							<InputText name="url" title="" placeholder="API Endpoint" inputProps={{ isRequired: true }} />
						</Box>
					</HStack>

					{/* API Headers */}
					<Box mb="10px">
						<Text fontSize="14px" mb="0px">Api Header</Text>
						{formData.headers.map((head, index) => (
							<HStack key={index} w="100%" mt="20px" alignItems="baseline">
								<Box w="30%">
									<InputText
										name={`headers[${index}].key`}
										title=""
										placeholder="key"
										onChange={(e) => handleHeaderChange(index, 'key', e)}
										inputProps={{ isRequired: true }}
									/>
								</Box>
								<Box w="60%">
									<InputText
										name={`headers[${index}].value`}
										title=""
										placeholder="value"
										onChange={(e) => handleHeaderChange(index, 'value', e)}
										inputProps={{ isRequired: true }}
									/>
								</Box>
								{index !== 0 && (
									<Box w="10%" onClick={() => removeHeader(index)}>
										<LuTrash2 style={{ cursor: 'pointer' }} />
									</Box>
								)}
							</HStack>
						))}
						<Button
							onClick={addHeader}
							bg="#FFFFFF"
							fontSize="12px"
							borderColor="#CCCCCC"
							borderWidth="1px"
							px="30px"
						>
							Add
						</Button>
					</Box>

					{/* API Payload Variables */}
					<Box mb="20px">
						<Text fontSize="14px" mb="0px">API Payload Variables</Text>
						{formData.payloads.map((head, index) => (
							<HStack key={index} w="100%" mt="20px" alignItems="baseline">
								<Box w="30%">
									<InputText
										name={`payloads[${index}].key`}
										title=""
										placeholder="key"
										onChange={(e) => handlePayloadChange(index, 'key', e)}
										inputProps={{ isRequired: true }}
									/>
								</Box>
								<Box w="60%">
									<InputText
										name={`payloads[${index}].value`}
										title=""
										placeholder="value"
										onChange={(e) => handlePayloadChange(index, 'value', e)}
										inputProps={{ isRequired: true }}
									/>
								</Box>
								{index !== 0 && (
									<Box w="10%" onClick={() => removePayload(index)}>
										<LuTrash2 style={{ cursor: 'pointer' }} />
									</Box>
								)}
							</HStack>
						))}
						<Button
							onClick={addPayload}
							bg="#FFFFFF"
							fontSize="12px"
							borderColor="#CCCCCC"
							borderWidth="1px"
							px="30px"
						>
							Add
						</Button>
					</Box>

					{/* JSON Preview */}
					<pre style={{ backgroundColor: 'black', textShadow: 'none', color: 'white', padding: '0px', borderRadius: '8px' }}>
						<span style={{ padding: 15, backgroundColor: '#2F2F2F', fontSize: '14px', display: 'block', marginBottom: '10px' }}>json</span>
						<code className="language-json" style={{ padding: '0px 15px 15px', display: 'block' }}>
							{JSON.stringify(payload, null, 2)}
						</code>
					</pre>

					{/* Status */}
					<Box w="30%">
						<SelectField name="status_id" title="Status" list={statusList} isRequired />
					</Box>

					{/* Submit / Cancel */}
					<HStack alignItems="baseline" w="100%" mt="10px">
						<Box>
							<Button
								py="10px" px="25px"
								color="#fff" bg="#2563eb"
								fontSize="14px" fontWeight="500"
								fontFamily="'Open Sans', sans-serif"
								mb={4}
								type="submit"
							>
								Add API Account
							</Button>
						</Box>
						<Box>
							<Button
								py="10px" px="25px"
								color="#000000" bg="#FFFFFF"
								fontSize="14px" fontWeight="500"
								fontFamily="'Open Sans', sans-serif"
								mb={4}
								borderColor="#CCCCCC"
								borderWidth="1px"
								onClick={() => getPage('list', channel_id)}
							>
								Cancel
							</Button>
						</Box>
					</HStack>

				</Form>
			</div>
		</>
	)
}

export default Create;